import tippy from "tippy.js";

function initTippy() {
    tippy("[data-tippy-content]", {
        interactive: true,
        allowHTML: true,
        theme: "default",
        arrow: true
    });
}
export default initTippy;
